export default __webpack_public_path__ + "static/media/lfp-button.1e95f17f.svg";